import { createBrowserHistory } from 'history';

export type { UnregisterCallback, History } from 'history';

export default createBrowserHistory({ basename: process.env.PUBLIC_URL });
